import clsx from 'clsx';
import type { ComponentProps } from 'react';
import styles from './Container.module.scss';
export const Container = ({
  children,
  className,
  ...props
}: ComponentProps<'div'>) => {
  return <div className={clsx(styles.wrap, className)} {...props} data-sentry-component="Container" data-sentry-source-file="Container.tsx">
      {children}
    </div>;
};